var frontpage_interactive_tabs = (function( $ ) {

	var _init = function() {
		$('#fp-latest-articles .section-title').click(function() {
			if (!$(this).hasClass('active')) {
				$('#fp-latest-articles .section-title').removeClass('active');
				$(this).addClass('active');

				$('#fp-latest-articles .articles, #fp-latest-articles .interactive-content-posts').toggle();

				toggle_links();
			}
		});
	};

	function toggle_links() {
		const interactive_link = $('.links .interactive-link');
		const article_link = $('.links .article-link');

		if (interactive_link.length) {
			if (interactive_link.is(':visible')) {
				interactive_link.hide();
				article_link.show();
			} else {
				article_link.hide();
				interactive_link.show();
			}
		}
	}

	$( document ).ready( _init );

	return {};

})( jQuery );

module.exports = frontpage_interactive_tabs;